var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "audio-manage" }, [_vm._t("head"), _vm._v(" "), _c('div', { staticClass: "list" }, _vm._l(_vm.resources, function (resource) {
    return _c('audio-item', { key: resource.id, ref: "audioItemRef", refInFor: true, attrs: { "resource": resource }, on: { "play": _vm.handlePlay, "addResource": _vm.handleAddResource } });
  }), 1)], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };